// extracted by mini-css-extract-plugin
export default {"root":"DashboardKeyValueRankingKpiCard_root__g3i3e"};